export default {
  methods: {
    /**
     * Resolves the display label for a trash item type. Application entries
     * carry their concrete kind (base, app, script, workflow); the label is
     * the one written for that kind, or failing that the kind's own name from
     * the registry — never the generic "application", which the interface
     * uses nowhere.
     */
    trashTypeLabel(trashItemType, applicationType = null) {
      if (applicationType) {
        const key = `trashType.${trashItemType}_${applicationType}`
        if (this.$te(key)) {
          return this.$t(key)
        }
        if (this.$registry.exists('application', applicationType)) {
          return this.$registry.get('application', applicationType).getName()
        }
      }
      return this.$t(`trashType.${trashItemType}`)
    },
  },
}
